export const VOUCHER_UPDATE_FORM_ID = Symbol("voucher-update-form-id");
